import { ChangeDetectorRef, inject, NgZone, OnDestroy, PLATFORM_ID, Pipe, PipeTransform } from '@angular/core';
import { filter, Subject, Subscription } from 'rxjs';
import { TimeagoCustomFormatter, TimeagoDefaultClock, TimeagoIntl } from 'ngx-timeago';
import { strings as englishShortStrings } from 'ngx-timeago/language-strings/en-short.js';

function dateParser(date: Date | string | number): Date {

  return date instanceof Date ? date : new Date(date);
}

@Pipe({
  name: 'timeago',
  standalone: true,
  pure: false
})
export class TimeagoPipe implements PipeTransform, OnDestroy {

  private readonly intl = new TimeagoIntl();
  private readonly clock = new TimeagoDefaultClock(inject(PLATFORM_ID));
  private readonly formatter = new TimeagoCustomFormatter(this.intl);
  private readonly cd = inject(ChangeDetectorRef);
  private readonly ngZone = inject(NgZone);

  private readonly stateChanges = new Subject<void>();
  private date?: number;
  private value = '';
  private clockSubscription?: Subscription;
  private stateSubscription?: Subscription;
  private intlSubscription?: Subscription;

  constructor() {

    this.intl.strings = englishShortStrings;

    this.intlSubscription = this.intl.changes.subscribe(() => this.stateChanges.next());

    this.ngZone.runOutsideAngular(() => {
      this.stateSubscription = this.stateChanges.subscribe(() => {
        this.value = this.formatter.format(this.date!);
        this.ngZone.run(() => this.cd.markForCheck());
      });
    });
  }

  transform(date: Date | string | number | null | undefined): string {

    if (!date) return '';

    const _date = dateParser(date).valueOf();
    if (this.date === _date) return this.value;

    this.date = _date;
    this.clockSubscription?.unsubscribe();
    this.clockSubscription = this.clock.tick(this.date).pipe(filter(() => true)).subscribe(() => this.stateChanges.next());
    this.stateChanges.next();

    return this.value;
  }

  ngOnDestroy(): void {

    this.clockSubscription?.unsubscribe();
    this.stateSubscription?.unsubscribe();
    this.intlSubscription?.unsubscribe();
  }
}
